import React, { useLayoutEffect } from 'react';
import { useAppDispatch } from '../../store/hooks';
import axios from '../../axios';
import { useFirebase } from '../../context';

export const ClientInterceptors: React.FC = () => {
  const dispatch = useAppDispatch();

  const { user } = useFirebase();

  useLayoutEffect(() => {
    const requestInterceptor = axios.interceptors.request.use(
      async (config) => {
        try {
          if (user && config.headers) {
            const token = await user.getIdToken();
            config.headers.Authorization = `Bearer ${token}`;
          }

          return config;
        } catch (e) {
          return Promise.reject(e);
        }
      }
    );

    const responseInterceptor = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        if (error.config?.retry) {
          error.config.retry -= 1;

          const delay = new Promise((resolve) => {
            setTimeout(() => {
              resolve(undefined);
            }, error.config.retryDelay || 1000);
          });

          return delay.then(() => axios(error.config));
        }

        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [dispatch, user]);

  return null;
};
